window.addEventListener("scroll", function () {
  const searchBar = document.querySelector(".wizzy-custom-search-input-parent");
  const autocomplete = document.querySelector(".wizzy-autocomplete-wrapper");
  const searchBarTop = searchBar.getBoundingClientRect().bottom;
  if (autocomplete) {
    autocomplete.style.setProperty("top", `${searchBarTop}px`, "important");
  }
});

let wizzyEvents = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {
      // console.log("BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER ==>",data);
      let recentCount = 0;
      const indexesToRemove = [];
      
      data.suggestions.forEach((item, index) => {
        if (item.group === "recentSearches" && item.isRecentSearch) {
          if (recentCount < 3) {
            recentCount++;
          } else {
            indexesToRemove.push(index); // mark for removal
          }
        }
      });
      
      // Remove from the end to avoid index shifting
      indexesToRemove.reverse().forEach(index => {
        data.suggestions.splice(index, 1);
      });
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      //data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: ".wizzy-custom-search-input-parent .wizzy-custom-search-input",
          type: "text",
        },
      ];
      data.filters.configs.keepOpenedInMobileAfterApply = !0;
      data.autocomplete.configs.defaultBehaviour.suggestions.defaultPool = [
        {
          value: "Creatine",
          valueHighlighted: "Creatine",
          filters: [],
          payload: [],
          section: "others",
        },
        {
          value: "Pre-workout",
          valueHighlighted: "Pre-workout",
          filters: [],
          payload: [],
          section: "others",
        },
        {
          value: "Omega-3 capsules",
          valueHighlighted: "Omega-3 capsules",
          filters: [],
          payload: [],
          section: "others",
        }
        // {
        //   value: "Supplements",
        //   valueHighlighted: "Supplements",
        //   filters: [],
        //   payload: [],
        //   section: "others",
        // },
        // {
        //   value: "Fish oil",
        //   valueHighlighted: "Fish oil",
        //   filters: [],
        //   payload: [],
        //   section: "others",
        // },
        // {
        //   value: "Shilajit",
        //   valueHighlighted: "Shilajit",
        //   filters: [],
        //   payload: [],
        //   section: "others",
        // },
        // {
        //   value: "Fitness combo",
        //   valueHighlighted: "Fitness combo",
        //   filters: [],
        //   payload: [],
        //   section: "others",
        // },
        // {
        //   value: "Electrolytes",
        //   valueHighlighted: "Electrolytes",
        //   filters: [],
        //   payload: [],
        //   section: "others",
        // },
      ];
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      // console.log("BEFORE_FILTERS_EXECUTED", data);
      if (
        data?.filters?.sort[0].field == "relevance" &&
        data?.filters?.type == "NO_RESULTS_FOUND"
      ) {
        data.filters.sort = [
          {
            field: "relevance",
            order: "asc",
          },
          {
            field: "product_wizzy-404-page-bestseller_sortOrder:float",
            order: "asc",
          },
        ];
      } else if (
        data?.filters?.sort[0].field == "relevance" &&
        data?.filters?.type == "AUTOCOMPLETE_DEFAULT"
      ) {
        data.filters.sort = [
          {
            field: "product_recommended_sortOrder:float",
            order: "asc",
          },
        ];
      }
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      //data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
        {
          dom: ".wizzy-custom-search-input-parent .wizzy-custom-search-input",
          type: "text",
        },
      ];
      window.wizzyConfig.common.lazyDOMConfig.identifiersToClickOnSearch = [
        {
          dom: ".wizzy-custom-search-input-parent .wizzy-custom-search-input",
          type: "text",
        },
      ];
      data.common.lazyDOMConfig.contentDOMIdentifiers[0] = "#site-main";
      data.filters.configs.keepOpenedInMobileAfterApply = !0;
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (data) {
      // console.log("After products transformed data : ", data);
      data.forEach((product) => {
        product.attributes.forEach((attr) => {
          if (attr.id === "product_avg_rating_loox") {
            product.avgRatings = parseFloat(attr.values[0].value[0]).toFixed(1);
          } else if (attr.id === "product_prodcut_type_veg_nonveg_custom") {
            product.isVeg = attr.values[0].value[0] === "veg" ? true : false;
          } else if (attr.id === "product_num_reviews_loox") {
            product.reviewNumData = attr.values[0].value[0];
            product.reviewNum = isNaN(attr.values[0].value[0])
              ? "0"
              : attr.values[0].value[0].toLocaleString();
          } else if (attr.id === "product_handle") {
            product.productHandle = attr.values[0].value[0];
          } else if (attr.id === "product_value_tags_new_arrival") {
            product.newArrivalTag = attr.values[0].value[0];
          }
        });
      });
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
      const firstFilterBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block"
      );
      if (firstFilterBlock) {
        if (firstFilterBlock.classList.contains("first-opened")) {
          firstFilterBlock.classList.remove("collapsed");
        }
      }
      // console.log("VIEW_RENDERED", data);
      function cart_up_date() {
        var datacar = "";
        $.getJSON("/cart.js", function (item) {
          $(".bdySctn .body .msg").html(""),
            item.items.forEach((data) => {
              $(".bdySctn .body .msg").append(`
          <div class="cart-item-list">
            <div class="left-section">
              <img src="${data.image}" alt="${data.product_title}">
            </div>
            <div class="right-section">
            <h2>${data.product_title}</h2>
            <div class="right-bottom-section">
              <div class="item-desc">
                Qty:  ${data.quantity}
              </div>
              <div class="item-desc" product-get="${data.id}">
               \u20B9 ${data.price / 100}.00
              </div>
            </div>
            </div>
      </div>`);
            });
        });
      }

      $("[wizzy-data-variant-id]").on("click", function (event) {
        event.preventDefault();
        var element = $(this),
          data_id = parseInt(element.attr("wizzy-data-variant-id")),
          data = { quantity: 1, id: data_id };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
          success: function (response) {
            // console.log("Product added to cart:", response);
            var newHtml = `
      <button class="go-to-cart-class data-variant-id">
       <a href="/cart" class="cart_success" id="cart">Go to cart
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <g id="Complete">
              <g id="arrow-right">
                <g>
                  <polyline data-name="Right" fill="none" id="Right-2" points="16.4 7 21.5 12 16.4 17" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></polyline>
                  <line fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" x1="2.5" x2="19.2" y1="12" y2="12"></line>
                </g>
              </g>
            </g>
          </svg>
        </a>
</button>`;
            element.replaceWith(newHtml),
              fetch("/cart.js")
                .then((response2) => response2.json())
                .then((cartData) => {
                  var totalcount = cartData.item_count;
                  $(".site-header-cart--count").attr(
                    "data-header-cart-count",
                    totalcount
                  );
                }),
              $(".site-header-cart--count").addClass("visible");
            const cartElement = $(".cart_success");
            cartElement.on("click", function (event2) {
              event2.preventDefault(), (window.location.href = "/cart");
            }),
              cartElement.addClass("go-to-cart-class data-variant-id"),
              setTimeout(() => {
                cart_up_date();
              }, 1e3);
          },
          error: function (error) {
            console.error("Error adding product to cart:", error);
          },
        });
      });
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      const firstFilterBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block"
      );
      if (firstFilterBlock) {
        if (firstFilterBlock.classList.contains("first-opened")) {
          firstFilterBlock.classList.remove("collapsed");
        }
      }
      // console.log("VIEW_RENDERED", data);
      function cart_up_date() {
        var datacar = "";
        $.getJSON("/cart.js", function (item) {
          $(".bdySctn .body .msg").html(""),
            item.items.forEach((data) => {
              $(".bdySctn .body .msg").append(`
          <div class="cart-item-list">
            <div class="left-section">
              <img src="${data.image}" alt="${data.product_title}">
            </div>
            <div class="right-section">
            <h2>${data.product_title}</h2>
            <div class="right-bottom-section">
              <div class="item-desc">
                Qty:  ${data.quantity}
              </div>
              <div class="item-desc" product-get="${data.id}">
               \u20B9 ${data.price / 100}.00
              </div>
            </div>
            </div>
      </div>`);
            });
        });
      }

      $("[wizzy-data-variant-id]").on("click", function (event) {
        event.preventDefault();
        var element = $(this),
          data_id = parseInt(element.attr("wizzy-data-variant-id")),
          data = { quantity: 1, id: data_id };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: JSON.stringify(data),
          contentType: "application/json",
          dataType: "json",
          success: function (response) {
            // console.log("Product added to cart:", response);
            var newHtml = `
                <button class="go-to-cart-class wizzy-data-variant-id">
                 <a href="/cart" class="cart_success" id="cart">Go to cart
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                      <g id="Complete">
                        <g id="arrow-right">
                          <g>
                            <polyline data-name="Right" fill="none" id="Right-2" points="16.4 7 21.5 12 16.4 17" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></polyline>
                            <line fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" x1="2.5" x2="19.2" y1="12" y2="12"></line>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </a>
          </button>`;
            element.replaceWith(newHtml),
              fetch("/cart.js")
                .then((response2) => response2.json())
                .then((cartData) => {
                  var totalcount = cartData.item_count;
                  $(".site-header-cart--count").attr(
                    "data-header-cart-count",
                    totalcount
                  );
                }),
              $(".site-header-cart--count").addClass("visible");
            const cartElement = $(".cart_success");
            cartElement.on("click", function (event2) {
              event2.preventDefault(), (window.location.href = "/cart");
            }),
              cartElement.addClass("go-to-cart-class wizzy-data-variant-id"),
              setTimeout(() => {
                cart_up_date();
              }, 1e3);
          },
          error: function (error) {
            console.error("Error adding product to cart:", error);
          },
        });
      });
      function updateButtonsBasedOnCart(cartData) {
        var DataItems = cartData.items;
        $("#grid_AddToCart").each(function () {
          for (
            var productVariantId = $(this).attr("wizzy-data-variant-id"), i = 0;
            i < DataItems.length;
            i++
          )
            if (DataItems[i].variant_id == productVariantId) {
              var newContent = `<button class="go-to-cart-class wizzy-data-variant-id color-hai" style="background: #2eb4ac;">
                <a href="/cart" class="cart_success" id="cart" style="color: #fff; text-decoration: none;">Go to cart
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                        <g id="Complete">
                            <g id="arrow-right">
                                <g>
                                    <polyline data-name="Right" fill="none" id="Right-2" points="16.4 7 21.5 12 16.4 17" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></polyline>
                                    <line fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" x1="2.5" x2="19.2" y1="12" y2="12"></line>
                                </g>
                            </g>
                        </g>
                    </svg>
                </a>
                </button>`;
              $(this).replaceWith(newContent);
            }
        });
      }
      function fetchCartDataAndUpdateButtons() {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cartData) => {
            updateButtonsBasedOnCart(cartData);
          });
      }
      setTimeout(function () {
        fetchCartDataAndUpdateButtons();
      }, 2e3);

      document
        .querySelectorAll(
          ".wizzy-search-filters-left.wizzy-v2 .wizzy-facet-body"
        )
        .forEach((facetBody) => {
          let listItems = facetBody.querySelectorAll(".wizzy-facet-list-item");
          let searchWrapper = facetBody.querySelector(".facet-search-wrapper");

          if (listItems.length === 1 && searchWrapper) {
            searchWrapper.classList.add("wizzy-none");
          }
        });

      return data;
    }
  );
};
window.onWizzyLoaded.push(wizzyEvents);
